import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  toString1n9qg6fb0b5i8 as toString,
} from '../Char.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Companion_instance12hgu5wjfa7g as Companion_instance,
  CharProgression45cqq4g7w3uj as CharProgression,
  Companion_instance2qx5twdgt0if1 as Companion_instance_0,
  IntProgressionfaq59u1bhfih as IntProgression,
} from './Progressions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from './Range.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.EMPTY_1 = new (CharRange())(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 === VOID) {
    Companion_instance;
    new (Companion())();
  }
  return Companion_instance_1;
}
var CharRangeClass;
function CharRange() {
  if (CharRangeClass === VOID) {
    class $ extends CharProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance();
        super(start, endInclusive, 1);
      }
      get_start_qjli63_k$() {
        return this.first_1;
      }
      get_start_iypx6h_k$() {
        return new (Char())(this.get_start_qjli63_k$());
      }
      get_endInclusive_onwxgk_k$() {
        return this.last_1;
      }
      get_endInclusive_r07xpi_k$() {
        return new (Char())(this.get_endInclusive_onwxgk_k$());
      }
      contains_egozq6_k$(value) {
        return Char__compareTo_impl_ypi4mb(this.first_1, value) <= 0 && Char__compareTo_impl_ypi4mb(value, this.last_1) <= 0;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_egozq6_k$(value instanceof Char() ? value.value_1 : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return Char__compareTo_impl_ypi4mb(this.first_1, this.last_1) > 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof CharRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp;
        if (this.isEmpty_y1axqb_k$()) {
          tmp = -1;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = this.first_1;
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          var tmp_0 = imul(31, tmp$ret$0);
          // Inline function 'kotlin.code' call
          var this_1 = this.last_1;
          tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
        }
        return tmp;
      }
      toString() {
        return toString(this.first_1) + '..' + toString(this.last_1);
      }
    }
    initMetadataForClass($, 'CharRange', VOID, VOID, [ClosedRange()]);
    CharRangeClass = $;
  }
  return CharRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        this.EMPTY_1 = new (IntRange())(1, 0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_2;
function Companion_getInstance_0() {
  if (Companion_instance_2 === VOID) {
    Companion_instance_0;
    new (Companion_0())();
  }
  return Companion_instance_2;
}
var IntRangeClass;
function IntRange() {
  if (IntRangeClass === VOID) {
    class $ extends IntProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance_0();
        super(start, endInclusive, 1);
      }
      get_start_iypx6h_k$() {
        return this.first_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.last_1;
      }
      contains_7q95ev_k$(value) {
        return this.first_1 <= value && value <= this.last_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_7q95ev_k$(typeof value === 'number' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return this.first_1 > this.last_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, this.first_1) + this.last_1 | 0;
      }
      toString() {
        return '' + this.first_1 + '..' + this.last_1;
      }
    }
    initMetadataForClass($, 'IntRange', VOID, VOID, [ClosedRange()]);
    IntRangeClass = $;
  }
  return IntRangeClass;
}
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstanceswkziix95xfy,
  CharRange as CharRange1dt3801jgpja5,
  IntRange as IntRange1cx8zvxgibbj2,
};
//endregion

//# sourceMappingURL=PrimitiveRanges.mjs.map
